"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMailingAddress = getMailingAddress;
const get_scan_center_details_1 = require("./get-scan-center-details");
const interfaces_1 = require("./interfaces");
function getMailingAddress({ publicId, scanCenter, }) {
    switch (scanCenter) {
        case interfaces_1.ScanCenterCodeEnum.IAB:
            return [
                `CAYA Postbox ${publicId}`,
                'Barbara-McClintock-Str. 11',
                '12489 Berlin',
            ];
        case interfaces_1.ScanCenterCodeEnum.ODS:
            return [`CAYA Postbox ${publicId}`, '11516 Berlin'];
        case interfaces_1.ActiveScanCenterCodeEnum.SPS:
            return [`CAYA Postbox ${publicId}`, '96035 Bamberg'];
        case interfaces_1.ActiveScanCenterCodeEnum.SRZ: {
            const details = (0, get_scan_center_details_1.getScanCenterDetails)({
                accountRegion: get_scan_center_details_1.ScanCenterAccountRegion.DE,
                scanCenter: interfaces_1.ActiveScanCenterCodeEnum.SRZ,
            });
            return [
                `CAYA Postbox ${publicId}`,
                details.streetAndHouseNumber,
                `${details.postCode} ${details.city}`,
            ];
        }
    }
    throw new Error('Invalid scan center. Mailing address not found.');
}
//# sourceMappingURL=get-mailing-address.js.map